import { Plus } from 'lucide-react'

import { Button, Tooltip } from '@/components/ui'
import { useCaseFacts } from '@/modules/projects/hooks'
import { MAX_FACTS_PER_CASE } from './limits'

const AT_CAP_REASON = `This case has ${MAX_FACTS_PER_CASE} facts, the most allowed. Delete one to add another.`

interface AddCaseFactButtonProps {
  isAdding: boolean
  onClick: () => void
}

export const AddCaseFactButton = ({
  isAdding,
  onClick,
}: AddCaseFactButtonProps) => {
  const isAtCap = useCaseFacts().length >= MAX_FACTS_PER_CASE

  return (
    <Tooltip content={isAtCap ? AT_CAP_REASON : null}>
      <span className="inline-flex">
        <Button
          theme="outline"
          size="sm"
          disabled={isAdding || isAtCap}
          onClick={onClick}
        >
          <Plus />
          Add fact
        </Button>
      </span>
    </Tooltip>
  )
}
